import React from 'react';

import Button from 'common/components/Button';
import { IMG_MACARON_URL } from 'common/configuration/constants';
import { LocalStorageKeys } from 'common/constants/LocalStorageKeys';
import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import { ModalNames } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import eventEmitter from 'common/services/events/eventEmitter';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';
import { setCapping } from 'common/tools/ui/capping-helper';

import styles from './styles.module.scss';

type CloseModal = () => void;

type Props = { closeModal: CloseModal };

const PromoteAffinityModal = ({ closeModal }: Props) => {
  return (
    <ReactModal
      size="small"
      title={trans('promote-affinity-modal.title')}
      className={styles.modal}
    >
      <img className={styles.img} src={IMG_MACARON_URL} />
      <p
        className={styles.text}
        dangerouslySetInnerHTML={{
          __html: trans('promote-affinity-modal.text')
        }}
      />
      <Button
        theme="inverse"
        href={path('userspace_permanent_speednoter')}
        onClick={() => {
          setCapping(LocalStorageKeys.PROMOTE_AFFINITY_MODAL_CAPPING);

          eventEmitter.emit(TrackingEventNames.PROMOTE_AFFINITY_CLICK);
          closeModal();
        }}
      >
        {trans('promote-affinity-modal.cta')}
      </Button>
    </ReactModal>
  );
};

export default buildReactDomModalModule(
  ModalNames.PROMOTE_AFFINITY,
  (params: any, closeModal: CloseModal) => {
    return <PromoteAffinityModal closeModal={closeModal} />;
  },
  () => {
    setCapping(LocalStorageKeys.PROMOTE_AFFINITY_MODAL_CAPPING);
  }
);
